import styled from 'styled-components'

export const TooltipContainer = styled.div`
	position: relative;
	display: inline-flex;
	align-items: center;
	cursor: help;
`

export const TooltipIcon = styled.span`
	font-size: 0.875rem;
	color: #6c757d;
	margin-left: 0.375rem;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background: transparent;
	transition: all 0.2s ease;

	&:hover {
		color: #495057;
	}
`

export const TooltipText = styled.div`
	position: absolute;
	bottom: 100%;
	left: 50%;
	transform: translateX(-50%);
	margin-bottom: 8px;
	padding: 10px 14px;
	background: #2c3e50;
	color: white;
	font-size: 0.75rem;
	border-radius: 6px;
	z-index: 1000;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	pointer-events: none;
	min-width: 280px;
	max-width: 320px;
	white-space: normal;
	text-align: left;
	line-height: 1.5;

	/* Arrow pointing down */
	&::after {
		content: '';
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		border: 5px solid transparent;
		border-top-color: #2c3e50;
	}
`

